// extracted by mini-css-extract-plugin
module.exports = {"call-notice":"call-notice-a6eecbdf6cfe7a97195a4b28baafa5e9"};